import React from 'react'
import Lottie from 'react-lottie'

import { generateDefaultOptions } from 'components/common/ReactLottieBase/config'

import ByeByeJSON from './bye-bye.json'
import * as Styles from './styles'

import { assetsBase } from '../constants'
import QuizContainerBorder from '../QuizContainerBorder'

const EndQuizScreen = () => {
    const defaultOptions = generateDefaultOptions(ByeByeJSON)
    const style = {
        width: '100%',
        height: '100%',
    }
    return (
        <Styles.Container>
            <Styles.ViewScreen>
                <Styles.ImageContainer>
                    <Styles.Image src={`${assetsBase}/OkayBye.svg`} />
                </Styles.ImageContainer>
                <Styles.LottieContainer>
                    <Lottie
                        isClickToPauseDisabled
                        speed={1}
                        style={style}
                        options={defaultOptions}
                    />
                </Styles.LottieContainer>
            </Styles.ViewScreen>
            <QuizContainerBorder />
        </Styles.Container>
    )
}

export default EndQuizScreen
